import React from 'react';
import { motion } from 'framer-motion';
import './loading.scss';

const Loading = () => {
  return (
    <motion.div 
      className="loading-overlay"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="loading-container">
        <motion.div 
          className="loading-logo"
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 360]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          Na_Sokah_Uz
        </motion.div>
        
        <div className="loading-spinner">
          {[...Array(8)].map((_, i) => (
            <motion.div
              key={i}
              className="spinner-dot"
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.3, 1, 0.3]
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.1,
                ease: "easeInOut"
              }}
            />
          ))}
        </div>
        
        <motion.p 
          className="loading-text"
          animate={{
            opacity: [0.5, 1, 0.5]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          Загружаем свежесть...
        </motion.p>
      </div>
    </motion.div>
  );
};

export default Loading;
